// Global Nav Position Setting
document.addEventListener('DOMContentLoaded', function () {
    const mq = window.matchMedia('(max-width: 1024px)');

    function checkBreakPoint(mq) {
        if (mq.matches) {
            $('.gNav').prependTo('.spNav');
            $('.gNav').removeClass('sticky-container');
            $('.gNav .menu').removeClass('sticky');
            $('.gNav .menu').removeClass('align-center');
            $('.gNav .menu').addClass('vertical');
        } else {
            $('.gNav').prependTo('header');
            $('.gNav').addClass('sticky-container');
            $('.gNav .menu').addClass('sticky');
            $('.gNav .menu').addClass('align-center');
            $('.gNav .menu').removeClass('vertical');
        }
    }
    mq.addListener(checkBreakPoint);
    checkBreakPoint(mq);
    
});